
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dbOS5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "auth", () => $99a3c3743d95721c$export$73693bad9f5880b0);
$parcel$export(module.exports, "db", () => $99a3c3743d95721c$export$f932f06c7eb6abeb);
$parcel$export(module.exports, "default", () => $99a3c3743d95721c$export$2e2bcd8739ae039);
parcelRequire("fhN3L");
var $7xvHX = parcelRequire("7xvHX");

var $6AR8M = parcelRequire("6AR8M");

var $ilpIi = parcelRequire("ilpIi");
const $99a3c3743d95721c$var$APP_NAME = "coadesc";
const $99a3c3743d95721c$var$firebaseConfig = {
    apiKey: "AIzaSyDAPUu0k3cqx-v1yos2MjbUnYXd2qX6fDs",
    authDomain: "coadesc-34711.firebaseapp.com",
    projectId: "coadesc-34711",
    storageBucket: "coadesc-34711.firebasestorage.app",
    messagingSenderId: "689475129073",
    appId: "1:689475129073:web:36deaa4b3f547dabd6a350",
    measurementId: "G-2Y7YTT6EZS"
};
const $99a3c3743d95721c$var$app = (0, $7xvHX.getApps)().some((app)=>app.name === $99a3c3743d95721c$var$APP_NAME) ? (0, $7xvHX.getApp)($99a3c3743d95721c$var$APP_NAME) : (0, $7xvHX.initializeApp)($99a3c3743d95721c$var$firebaseConfig, $99a3c3743d95721c$var$APP_NAME);
const $99a3c3743d95721c$export$73693bad9f5880b0 = (0, $6AR8M.getAuth)($99a3c3743d95721c$var$app);
(0, $6AR8M.setPersistence)($99a3c3743d95721c$export$73693bad9f5880b0, (0, $6AR8M.browserLocalPersistence)).catch((error)=>{
    console.warn("Persist\xeancia Auth:", error);
});
const $99a3c3743d95721c$export$f932f06c7eb6abeb = (0, $ilpIi.getFirestore)($99a3c3743d95721c$var$app);
var $99a3c3743d95721c$export$2e2bcd8739ae039 = $99a3c3743d95721c$var$app;

});
parcelRegister("fhN3L", function(module, exports) {
$parcel$export(module.exports, "getApp", () => (parcelRequire("7xvHX")).getApp);
$parcel$export(module.exports, "getApps", () => (parcelRequire("7xvHX")).getApps);
$parcel$export(module.exports, "initializeApp", () => (parcelRequire("7xvHX")).initializeApp);
$parcel$export(module.exports, "registerVersion", () => (parcelRequire("7xvHX")).registerVersion);

var $7xvHX = parcelRequire("7xvHX");
var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "10.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $7xvHX.registerVersion)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, "app");

});



parcelRequire("dbOS5");

//# sourceMappingURL=firebase-init-coadesc.a6d910f2.js.map
